import { authwsEnvironment } from '../authws-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { AuthHeaders } from '../../../models/auth-headers';
import { ssoUserSchema } from '../schemas/sso-user.schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Create a new SSO user. This does not associated them to any account, so it's only available to be used by alk admins.
 * @param email user's email or username
 * @param firstName user's first name
 * @param lastName user's last name
 * @param password user's password (Optional)
 * @param alias account alias (only needed for non-email users)
 * @returns newly created user info
 */
export function postUsers(
  this: unknown,
  request: {
    email: string;
    firstName: string;
    lastName: string;
    password?: string;
    alias?: string;
  }
) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).usersUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify(request),
    })
  ).pipe(selectData(ssoUserSchema));
}
